module.exports = __webpack_public_path__ + "img/waist.84037aa0.png";